module.exports = "<div ng-if=\"!vm.hide\"\n     class=\"mb\"\n     mb-pageloader\n     ng-class=\"{'mb-pageloader-active':vm.active}\">\n\t<div class=\"mb-pl-container\">\n\t\t<cp-loading-sg></cp-loading-sg>\n\t\t<label style=\"margin-top: -24px; color: #284563;\">{{ vm.text }}</label>\n\t</div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/pageloader/templates/pageloader.template.html
// module id = 185
// module chunks = 0